export const GAMES_INFO = 'games-info';
